// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3sUyN","error":"Textarea_error__30Dil","readonly":"Textarea_readonly__JDqVQ","disabled":"Textarea_disabled___SH8Q"};